import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import { FaSortDown, FaSortUp, FaExclamationTriangle } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Confirm from '../../components/UI/Confirm/Confirm';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Switch from '../../components/UI/Switch/Switch';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { sortDataByKey } from '../../shared/utility';
import * as actions from '../../store/actions/index';
import classes from './GroupsList.css';
import ErrorAlert from '../../shared/Alert/ErrorAlert';

class GroupsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upArrow: true,
      success: false,
      error: false,
      deviceReset: false,
      confirmModal: null,
      confirmAction: null,
      action: null,
      message: null,
      groups: null,
      currentRecords: this.buildDeviceGroupData(this.props.groups, this.props),
      sortBy: '',
      sortDirection: '',
      steeringDevices:false
    };
    this.resetUpArrow = this.resetUpArrow.bind(this);
    this.handleTogglePause = this.handleTogglePause.bind(this);
    // this.handleGroupSteering = this.handleGroupSteering.bind(this);
    this.closeScheduleSteeringMessageModal = this.closeScheduleSteeringMessageModal.bind(this);
  }

  componentWillReceiveProps(nextProps, prevState) {

    if (!prevState.currentRecords && nextProps.groups && nextProps.groups.length) {
      this.setState({
        currentRecords: this.buildDeviceGroupData(nextProps.groups, nextProps)
      })
    }
  }

  openHandler() {

    this.setState({
      upArrow: true
    })
  }

  closeHandler() {
    this.setState({
      upArrow: false
    })
  }

  resetUpArrow() {
    this.setState({
      upArrow: false
    })
  }

  isGroupPauseToggleOn = (group) => {
    if (this.state.action === null) {
      return group.freeze.frozen;
    }
    let { togglePause, groupId } = this.state.action;
    if (!groupId || groupId !== group.id) {
      return group.freeze.frozen;
    }
    if (this.state.confirmAction === 'cancel') {
      return !togglePause;
    }
    return togglePause;
  }

  confirmModalConfirmHandler = () => {
    let { togglePause, groupId } = this.state.action;
    let actions = [];
    if (togglePause) {
      if (this.isSuspendScheduleEnabled(groupId)) {
        actions.push({ templateId: 'suspend', action: 'DELETE' })
      }
      if (this.isCustomScheduleEnabled(groupId)) {
        actions.push({ templateId: 'untilMidnight', action: 'PUT' })
      } else {
        actions.push({ templateId: 'forever', action: 'PUT' })
      }
    } else {
      if (this.isCustomScheduleEnabled(groupId)) {
        actions.push({ templateId: 'suspend', action: 'PUT' })
      } else {
        actions.push({ templateId: 'freezes', action: 'DELETE' })
      }
    }

    actions.forEach(action => {
      if (action.templateId === 'freezes') {
        this.props.onFreezeDeviceGroup({ deviceGroupId: groupId });
      } else {
        this.props.onPauseDeviceGroup({ deviceGroupId: groupId, templateId: action.templateId, action: action.action });
      }
    });

    this.confirmModalCancelHandler('ok')
  }

  confirmModalCancelHandler = (e, confirmAction = 'cancel') => {
    // The first argument of this handler must be the browser event, otherwise confusing things happen

    this.setState((oldState) => ({
      confirmModal: false,
      confirmAction: confirmAction,
      groups: [...oldState.groups]
    }));
  }

  onOpenModal = (message, action, currentGroupIdx) => {
    this.setState({
      confirmModal: true,
      message,
      action,
      currentGroupIdx,
    })
  }

  getDeviceGroup = (groupId) => {
    if (!this.state.groups) {
      return undefined;
    }
    let groups = this.state.groups.filter(g => g.id === groupId)
    if (groups.length === 0) {
      return undefined;
    }
    return groups[0];
  }

  isSuspendScheduleEnabled = (groupId) => {
    let group = this.getDeviceGroup(groupId);
    if (!group || !group.freeze) {
      return false;
    }
    let suspended = group.freeze.suspended;
    if (!suspended) {
      return false;
    }
    return suspended.enable;
  }

  isCustomScheduleEnabled = (groupId) => {
    let group = this.getDeviceGroup(groupId);
    if (!group || !group.freeze) {
      return false;
    }

    let templates = group.freeze.timeTemplates;
    if (!templates) {
      return false;
    }
    let template = templates.filter(t => t.id === 'custom');
    if (template.length === 0) {
      return false;
    }

    return template[0].enable;
  }

  handleTogglePause = (checked, groupId, idx) => {
    const group = this.getDeviceGroup(groupId);
    
    // if(!this.handleGroupSteering(group.devices)){
      if (checked) {
        const modalContent = (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <h2 style={{ whiteSpace: 'nowrap' }}>Activate A Group Pause</h2>
          <p style={{ fontWeight: 'normal', textAlign: 'center' }}>This will pause all internet connectivity to the devices in this group</p>
          <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>Are you sure you want to proceed?</p>
        </div>)
        this.onOpenModal(modalContent, { togglePause: checked, groupId: groupId }, idx);
      } else {
        const modalContent = (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <h2 style={{ whiteSpace: 'nowrap' }}>Activate A Group Unpause</h2>
          <p style={{ fontWeight: 'normal', textAlign: 'center' }}>This will unpause all internet connectivity to the devices in this group</p>
          <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>Are you sure you want to proceed?</p>
        </div>)
        this.onOpenModal(modalContent, { togglePause: checked, groupId: groupId }, idx);
      }
    
  }

  getDeviceStatus = (group) => {
    if (!group.devices) {
      return [];
    }
    let connectedDevices = group.devices.filter(device => device.connectionState === 'connected');
    let disconnectedDevices = group.devices.filter(device => device.connectionState !== 'connected');
    let pausedDevices = group.devices.filter(device => (device.freeze && device.freeze.frozen === true));
    return [connectedDevices, disconnectedDevices, pausedDevices];
  }

  getDeviceStatusText = (status) => {
    if (!status || status.length === 0) {
      return (
        <div> N/A</div>
      )
    }
    return (
      <div>
        <span id="Connected" className={classes.statusName} style={{ color: 'green' }}> {status[0].length} Connected </span> &nbsp;
        <span id="Disconnected" className={classes.statusName} style={{ color: 'red' }}> {status[1].length} Disconnected</span> &nbsp;
        <span id="Paused" className={classes.statusName} style={{ color: 'gray' }}> {status[2].length} Paused </span>
      </div>
    )



  }

  sortTable = (propertyName) => {
    const { sortDirection, currentRecords } = this.state;
    const records = sortDataByKey(currentRecords, propertyName, sortDirection);
    this.setState({
      currentRecords: records,
      sortDirection: sortDirection === '' || sortDirection === 'desc' ? 'asc' : 'desc',
      sortBy: propertyName
    })
  }

  buildDeviceGroupData(groups = [], nextProps) {
    return groups.map((group) => {
      group.groupName = group.nickname || '';
      return group;
    });
  }

  getGroupRow = (group, idx, hideGroupName = false) => {
    let name = group.nickname;    
    if (name && name.length > 12) {
      name = name.substring(0, 12) + '...';
    }
    let deviceStatus = this.getDeviceStatusText(this.getDeviceStatus(group));
    let nameStyle = { borderRight: 'none', borderLeft: 'none', borderBottom: '1px solid lightgray' };

    if (hideGroupName) {
      nameStyle = { display: 'none', ...nameStyle }
    }

    let groupPauseToggle = (
      <div className={classes.leftDetails}>
        <Switch id='GroupListToggle'
          key={group.id}
          disabled={!(group && group.devices && group.devices.length)}
          onColor='#0073d1'
          width={66}
          onChange={() => this.handleTogglePause(!this.state.currentRecords[idx].freeze.frozen, group.id, idx)}
          checked={this.state.currentRecords[idx].freeze.frozen}
        />
      </div>
    )

    return (
      <tr className={classes.trTag}>
        <td style={nameStyle}>
          <span id='ExistingGroupName' style={{ marginLeft: '10px', whiteSpace: 'pre', cursor: 'pointer' }} className={[classes.devName, classes.RegularButton].join(' ')}
            onClick={() => this.props.showGroupDetails(group)}>{name}</span></td>
        <td style={{ borderRight: 'none', borderLeft: 'none', borderBottom: '1px solid lightgray' }}>{deviceStatus}</td>
        <td style={{ padding: '10px', borderRight: 'none', borderLeft: 'none', borderBottom: '1px solid lightgray' }}>{groupPauseToggle}</td>
      </tr>
    )
  }

  getGroupNameRow = (group) => {
    let name = group.nickname;    
    if (name && name.length > 12) {
      name = name.substring(0, 12) + '...';
    }
    let deviceStatus = this.getDeviceStatusText(this.getDeviceStatus(group));

    return (
      <Box>
        <tr>
          <td style={{ borderRight: 'none', borderLeft: 'none', padding: '10px', borderBottom: '1px solid lightgray', display: 'flex' }}>
            <span style={{ display: 'block', marginLeft: '10px', overflowWrap: 'break-word', width: '140px', whiteSpace: 'pre-wrap', cursor: 'pointer', paddingTop:'11px' }} className={[classes.devName, classes.RegularButtonForMobile].join(' ')}
              onClick={() => this.props.showGroupDetails(group)}>{name}</span>
          </td>
        </tr>
      </Box>
    )
  }

  getGroupRows = (hideGroupName = false) => {
    let groupRows = [];
    if (!this.state.currentRecords) {
      return [];
    }

    return this.state.currentRecords.map((g, i) => this.getGroupRow(g, i, hideGroupName));
  };

  getGroupNameRows = () => {
    let groupRows = [];
    if (!this.state.currentRecords) {
      return [];
    }
    return this.state.currentRecords.map(g => this.getGroupNameRow(g));
  };

  getGroupTable = (targetView) => {
    let sortIcon;
    const { sortDirection, sortBy, currentRecords } = this.state;
    if (sortDirection === 'asc') {
      sortIcon = (<FaSortUp fontSize={'12px'} />);
    } else if (sortDirection === 'desc') {
      sortIcon = (<FaSortDown fontSize={'12px'} />);
    }
    if (this.props.loading || !this.props.loaded || (this.props.wan && this.props.wan.checkingWan)) {
      return (
        <Spinner />
      )
    }
    if(this.props.apiNotFound) {
      return (
        <ErrorAlert />
      )
    }
    if (!this.state.groups || this.state.groups.length === 0) {
      return (
        <div className={classes.tablewrapper}>
          <div className={classes.Spacer} />
          <div style={{ color: 'gray', textAlign: 'center' }}>
            There is no Group Information available at this time
          </div>
          <div className={classes.Spacer} />
        </div>
      )
    }
    let groupPauseColumn = (
      <th style={{ borderLeft: 'none', borderRight: 'none', textAlign: 'left', padding: '16px', color: 'grey', borderBottom: '1px solid lightgrey' }}>Group Pause</th>
    )
    let tableForDesktop = (<div className={classes.tablewrapper}>
      <table className={classes.devTable} cellPadding="0" cellSpacing="0" >
        <thead>
          <tr className={classes.trTag}>
            <th style={{
              borderLeft: 'none', borderRight: 'none', textAlign: 'left', padding: '16px', color: 'grey',
              borderBottom: '1px solid lightgrey'
            }} onClick={() => { this.sortTable('groupName') }}>Group Name {sortBy === 'groupName' && sortIcon}</th>
            <th style={{ borderLeft: 'none', borderRight: 'none', textAlign: 'left', padding: '16px', color: 'grey', borderBottom: '1px solid lightgrey' }}>Device Status</th>
            {groupPauseColumn}
          </tr>
        </thead>
        <tbody>
          {this.getGroupRows()}
        </tbody>
      </table>
    </div>);

    let table1 = this.getGroupNameTable();
    let table2 = (<div className={classes.tablewrapper}>
      <table className={classes.devTable} cellPadding="0" cellSpacing="0" >
        <thead>
          <tr className={classes.trTag} style={{ whiteSpace: 'pre' }}>
            <th style={{
              borderLeft: 'none', borderRight: 'none', textAlign: 'left', padding: '16px', color: 'grey',
              borderBottom: '1px solid lightgrey', display: 'none'
            }} onClick={() => { this.sortTable('groupName') }}>Group Name {sortBy === 'groupName' && sortIcon}</th>
            <th style={{ borderLeft: 'none', borderRight: 'none', textAlign: 'left', padding: '16px', color: 'grey', borderBottom: '1px solid lightgrey' }}>Device Status</th>
            <th style={{ borderLeft: 'none', borderRight: 'none', textAlign: 'left', padding: '16px', color: 'grey', borderBottom: '1px solid lightgrey' }}>Group Pause</th>
          </tr>
        </thead>
        <tbody>
          {this.getGroupRows(true)}
        </tbody>
      </table>
    </div>
    );

    if (targetView === 'Desktop') {
      return tableForDesktop;
    } else {
      return (
        <div style={{ display: 'inline-block' }}>
          {table1}
          {table2}
        </div>
      )
    }
  }

  successErrorResetHandler = () => { this.props.onResetPauseDeviceGroupSuccessError(); };

  getGroupNameTable = () => {

    let sortIcon;
    const { sortDirection, sortBy, currentRecords } = this.state;
    if (sortDirection === 'asc') {
      sortIcon = (<FaSortUp fontSize={'12px'} />);
    } else if (sortDirection === 'desc') {
      sortIcon = (<FaSortDown fontSize={'12px'} />);
    }
    let table = (<div style={{ float: 'left' }}>
      <table className={classes.devTable} cellPadding="0" cellSpacing="0">
        <thead>
          <tr className={classes.trTag}>
            <th style={{
              borderLeft: 'none', borderRight: 'none', textAlign: 'left', padding: '16px', color: 'grey',
              borderBottom: '1px solid lightgrey'
            }} onClick={() => { this.sortTable('groupName') }}>Group Name {sortBy === 'groupName' && sortIcon}</th>
          </tr>
        </thead>
        <tbody>
          {this.getGroupNameRows()}
        </tbody>
      </table>
    </div>);
    return table;
  }

  handleGroupSteering = (devices) => {
    // console.log(' devices ::::', devices, grpDetails);
     let steeringDevices = 
     devices ? devices.map((device)=>{       
         if (device.steering && device.steering.forced && device.steering.forced.freqBand && typeof device.steering.forced.freqBand === 'string') {
           const freq = device.steering && device.steering.forced && device.steering.forced.freqBand && device.steering.forced.freqBand.includes('2.4G');
           return freq
         }         
       }) 
       : '';
     if(steeringDevices.includes(true)){
        this.setState({ 
          steeringDevices : true
        });
        return true;          
     }
     return false;
  }

  closeScheduleSteeringMessageModal(){
    this.setState({
      steeringDevices : false
    })
  }


  render() {
    let st = new Date();
    if (this.props.groups !== this.state.groups) {
      this.setState({
        groups: this.props.groups
      });
    }
    let arrow = (
      <MdKeyboardArrowDown
        color={'gray'}
        size={'30px'} />
    )
    if (this.state.upArrow) {

      arrow = (
        <MdKeyboardArrowUp
          color={'gray'}
          size={'30px'} />

      )
    } else {

      arrow = (
        <MdKeyboardArrowDown
          color={'gray'}
          size={'30px'} />

      )
    }

    if (this.props.pauseDeviceGroupError && !this.state.error) {
      this.setState({ error: true })
      this.props.onResetGroupsErrorSuccess()
    }
    if (this.props.pauseDeviceGroupSuccess && !this.state.success) {
      this.setState({ success: true })
      this.props.onResetGroupsErrorSuccess()
    }

    let equipNameData;

    st = new Date();
    return (
      <Box>
        <div className={classes.showDesktop}>
          <div className={classes.GroupsListComponent}>
            <Collapsible

              transitionTime={100}
              open={true}
              onOpening={
                () => { this.openHandler() }

              }
              onClosing={
                () => { this.closeHandler() }
              }
              trigger={
                (<Box>
                  <div className={[classes.showMobile1, classes.GroupsListComponentCollapse].join(' ')}>
                    {/* <div className={classes.GroupsListComponentCollapse}> */}
                    <div className={classes.TitleArea}>

                      <h3 id='ExistingGroups' style={{ paddingRight: 20, cursor: 'pointer' }}>Existing Groups</h3>
                      <button className={classes.OpenCloseButton} style={{ float: 'right' }} aria-label="open arrow">
                        {arrow}
                      </button></div>

                    <div className={classes.HorizontalSeparator} />

                  </div>
                </Box>)
              }>
              {this.getGroupTable('Desktop')}
            </Collapsible>
          </div>
        </div>

        <div className={classes.showMobile}>
          <div className={classes.GroupsListComponent}>
            <Collapsible
              transitionTime={100}
              open={true}
              onOpening={() => { this.openHandler() }}
              onClosing={() => { this.closeHandler() }}
              trigger={
                (<Box>
                  <div className={[classes.showMobile1, classes.GroupsListComponentCollapse].join(' ')}>
                    <div className={classes.TitleArea}>
                      <h3 style={{ paddingRight: 20 }}>Existing Groups</h3>
                      <button className={classes.OpenCloseButton} style={{ float: 'right' }} aria-label="open arrow">
                        {arrow}
                      </button>
                    </div>
                    <div className={classes.HorizontalSeparator} />
                  </div>
                </Box>)}
              overflowWhenOpen='scroll'
            >
              {this.getGroupTable('Mobile')}
            </Collapsible>
          </div>
        </div>

        <Modal deviceGroupConfirmation="true" show={this.state.confirmModal} modalClosed={() => this.confirmModalCancelHandler('cancel')}>
          <Confirm id={'GroupListPauseConfirm'}
            deviceGroupConfirmation={true}
            action={'togglePause'}
            result={this.state.message}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Yes"
            hideActionText={true}
          />
        </Modal>
        <Modal show={this.props.pauseDeviceGroupError} modalClosed={this.successErrorResetHandler}>
          <Error />
        </Modal>
        <Modal show={this.props.pauseDeviceGroupSuccess} modalClosed={this.successErrorResetHandler}>
          <Success />
        </Modal>
        {/* {this.state.steeringDevices && (
          <Modal
          id="DSAlertMsgGroupListPage"
          deviceGroupConfirmation="true"
          show={this.state.steeringDevices}
         modalClosed={this.closeScheduleSteeringMessageModal}
        >
         <div>
           <div style={{ display:'flex', flexDirection:'row', padding: '25px 5px 5px 5px' }}>
              <FaExclamationTriangle
              id = 'DSAlertIcon'
              color={'red'}
              fontSize={'80px'}
              style={{ marginRight: '5px', marginTop: '8px' }} />
              <p  id = 'DSGroupListModalWarning' style={{ textAlign: 'center', fontWeight: 'normal' }}>
              The selected smartphone/tablet has been steered and must not be paused or scheduled to begin a scheduled pause in the next 60 minutes.
              </p>
            </div>
            <button className={classes.SteeringRegularButton} onClick={this.closeScheduleSteeringMessageModal}>
              OK
            </button>
          </div>                              
        </Modal>
        )} */}
      </Box>

    )
  }

}

const mapStateToProps = (state => {
  return {
    success: state.deviceGroups.success,
    error: state.deviceGroups.error,
    apiNotFound: state.deviceGroups.apiNotFound,
    pauseDeviceGroupLoading: state.deviceGroups.pauseDeviceGroupLoading,
    pauseDeviceGroupSuccess: state.deviceGroups.pauseDeviceGroupSuccess,
    pauseDeviceGroupError: state.deviceGroups.pauseDeviceGroupError,
    selectedEquipment: state.equipment.selectedEquipment,
    wan: state.wan
  };
});

const mapDispatchToProps = (dispatch) => {
  return {
    onResetGroupsErrorSuccess: () => dispatch(actions.resetGroupsErrorSuccess()),
    onResetPauseDeviceGroupSuccessError: () => dispatch(actions.resetPauseDeviceGroupSuccessError()),
    onPauseDeviceGroup: (data) => dispatch(actions.pauseDeviceGroup(data)),
    onFreezeDeviceGroup: (data) => dispatch(actions.freezeDeviceGroup(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(GroupsList, api));
